import React from "react";
import {
  areCanonicalDecimalsEqual,
  formatServiceCost,
  formatServiceCostWholeRupiah,
  isCanonicalDecimalZero,
  serviceCostSummary,
} from "../../lib/serviceCost";

export default function ServiceCostPresentation({ serviceCost, grandTotal, compact = false, serviceTable = false, quotationHistory = false }) {
  if (!serviceCost) return <span className="text-muted-foreground">-</span>;
  const summary = serviceCostSummary(serviceCost);
  const formatMoney = serviceTable ? formatServiceCostWholeRupiah : formatServiceCost;
  const showGross = quotationHistory || serviceTable
    ? !areCanonicalDecimalsEqual(summary.gross, summary.final)
    : !isCanonicalDecimalZero(summary.effectiveDiscount);
  return (
    <div className={compact ? "leading-tight" : "space-y-1"} data-testid="service-cost-presentation">
      <div className="font-semibold tabular-nums text-foreground">
        {formatMoney(summary.final)}
      </div>
      {showGross ? (
        <div className="text-[11px] tabular-nums text-muted-foreground">
          {serviceTable || quotationHistory
            ? formatMoney(summary.gross)
            : `Gross ${formatServiceCost(summary.gross)} · ${summary.effectiveDiscount}% discount`}
        </div>
      ) : null}
      {grandTotal !== undefined && !quotationHistory ? (
        <div className="text-[11px] tabular-nums text-muted-foreground">
          Grand Total {formatServiceCost(grandTotal)}
        </div>
      ) : null}
    </div>
  );
}
